import { MiddleTruncatedText } from 'features/knowledgeDocumentViewer/components/MiddleTruncatedText'
import { ChartSearchItem } from 'features/knowledgeDocumentViewer/types/searchableItems'
import { Activity, LineChart } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const CARD_WIDTH = 120
const ICON_AREA_HEIGHT = 100

const Card = styled.button<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${CARD_WIDTH}px;
  flex-shrink: 0;
  padding: 0.25rem;
  background: ${(props) =>
    props.$isSelected
      ? props.theme.forecast.activeButton
      : props.theme.forecast.defaultButton};
  border-radius: 0.25rem;
  overflow: hidden;
  cursor: pointer;
  text-align: left;
  border: 2px solid transparent;

  &:hover {
    background-color: ${(props) =>
      props.$isSelected
        ? props.theme.forecast.hoverGhostButton
        : props.theme.forecast.hoverButton};
  }
  &:active {
    background-color: ${(props) => props.theme.forecast.activeButton};
    color: ${(props) => props.theme.forecast.activeText};
  }
`

const IconArea = styled.div`
  width: 100%;
  height: ${ICON_AREA_HEIGHT}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  background-color: ${(props) => props.theme.forecast.cardGroupBackground};
  color: ${(props) => props.theme.forecast.secondaryText};
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.375rem 0.25rem 0 0.25rem;
  gap: 0.125rem;
`

const SensorCountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.5625rem;
  color: ${(props) => props.theme.forecast.secondaryText};
`

const Title = styled.div`
  font-size: 0.6875rem;
  font-weight: 500;
  color: ${(props) => props.theme.forecast.defaultText};
`

interface RecentChartCardProps {
  chart: ChartSearchItem
  isSelected?: boolean
  onClick: (chart: ChartSearchItem, event?: React.MouseEvent) => void
}

export const RecentChartCard: React.FC<RecentChartCardProps> = ({
  chart,
  isSelected = false,
  onClick,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    onClick(chart, event)
  }

  const sensorCount = chart.sensorIds.length

  return (
    <Card onClick={handleClick} $isSelected={isSelected}>
      <IconArea>
        <LineChart size={28} />
      </IconArea>
      <CardContent>
        {sensorCount > 0 && (
          <SensorCountRow>
            <Activity size={10} />
            {sensorCount} {sensorCount === 1 ? 'sensor' : 'sensors'}
          </SensorCountRow>
        )}
        <Title>
          <MiddleTruncatedText
            text={chart.displayName}
            maxWidth='100%'
            fillWidth
            tooltipFontSize='0.6875rem'
          />
        </Title>
      </CardContent>
    </Card>
  )
}
